import React, { MutableRefObject } from 'react';

import { MetricValue } from 'src/graphql';
import { MetricCellHeader, MetricCellSaaS } from 'src/components';
import { MetricCode, ScoreArrowType } from 'src/types';
import { MetricCell } from './';

interface Params {
  metricValue: MetricValue;
  colSpan: number;
  idx: number;
  prevMetricValue: MutableRefObject<any>;
  date: string;
  metricCode: MetricCode;
  metricName: string;
  arrowType: ScoreArrowType | null;
}

export const renderValueColumn = ({
  metricValue,
  colSpan,
  idx,
  date,
  metricCode,
  metricName,
  arrowType,
}: Params): React.ReactNode => {
  const settings: Record<any, any> = {
    children: null,
    props: {},
  };

  switch (idx) {
    case 0: {
      settings.children = <MetricCellSaaS arrowType={arrowType} metricValue={metricValue} />;
      settings.props.colSpan = colSpan;
      settings.props.align = 'center';
      break;
    }
    case 1: {
      settings.children = <MetricCellHeader type="value" />;
      settings.props.align = 'center';
      break;
    }
    default: {
      settings.children = (
        <MetricCell
          value={metricValue}
          date={date}
          metricCode={metricCode}
          metricName={metricName}
          metricIndex={idx}
        />
      );
    }
  }

  return settings;
};
